<template>
  <div class="popwin-coin">
    <template v-for="i in 9">
      <div
        :key="i"
        :class="['coin','coin'+i,{forwards:i===9}]"
        :style="{
          animationDelay:.07*i+delayTime +'s',
          transform: 'rotateZ('+rotateDeg +'deg)',
          backgroundPosition:-(i-1) *60 +'px 0'
        }"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Coins',
  props: {
    delayTime: {
      type: Number,
      default: 0
    },
    rotateDeg: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.popwin-coin {
  position: relative;
  width: 60/@rem;
  height: 60/@rem;

  .coin {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation-duration: 0.08s;
    animation-name: fade_in;
    animation-timing-function: cubic-bezier(0.41, 1.14, 0.13, -0.12);
    background-image: url("../images/winning/coins.png");
    background-size: cover;
    opacity: 0;

    &.forwards {
      animation-fill-mode: forwards;
    }
  }

  @keyframes fade_in {
    0% {
      opacity: 0;
    }

    1%,
    100% {
      opacity: 1;
    }
  }
}

</style>
